<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png"><span>维修耗材出库记账</span>
      </div>
      <div class="common head-wrapper">
        <div class="layout row">
          <label>关联维修单：</label>
          <span class="flex-1">24523542345（受理中）</span>
        </div>
        <div class="layout row">
          <label>仓库：</label>
          <span class="flex-1" @click="warehouseClick()">小区名-仓库名<img class="warearrow" src="../../../assets/images/right_jt.png"></span>
        </div>
        <!-- 上传图片 -->
        <div class="uploadImg">
          <div class="uploadImgFile">
            <input class="uploadImg" @change="uploadFile" type="file">
          </div>
          <div class="uploadImgList" v-for="(image, image_key) in imageList" :key="image_key">
            <img class="img" :src="image" @click="previewImage(image)">
            <img class="del" @click="deleteImage(image_key)" src="../../../assets/images/repairman-del.png">
          </div>
        </div>
        <!-- 预览图片 -->
        <div class="previewimg" v-if="previewFile">
          <div @click="previewclose"></div>
          <img :src="previewimg">
        </div>
      </div>
      <div class="common remarks-wrapper">
        <div>备注</div>
        <div class="remarks-textarea">
          <textarea placeholder="请输入备注"></textarea>
        </div>
      </div>
    </div>
    <div class="backdrop-bottom">
      <button class="preserve-btn">保存草稿</button>
      <button class="entry-btn">入账</button>
    </div>
    <!-- 选择仓库弹出框 -->
    <div class="warehouselist" v-if="warehouseList">
      <div class="warehouselist-top" @click="clickBlank"></div>
      <div class="warehouselist-bottom">
        <label>仓库名称1</label>
        <label>仓库名称2</label>
        <label>仓库名称3</label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WarehouseOutAccount',
  metaInfo: {
    title: '物资管理'
  },
  data () {
    return {
      imageList: [], // 保存图片集合
      imageListId: [], // 选中的图片id
      previewimg: '', // 预览图片
      previewFile: false, // 预览默认关闭
      maxSize: 500, // 上传图片限制最大为500kb
      formData: '',
      access_token: '', // tob access_token
      warehouseList: false // 选择仓库弹出框
    }
  },
  created () {
    this.getAccessToken()
  },
  methods: {
    warehouseClick () {
      this.warehouseList = true
    },
    clickBlank () {
      this.warehouseList = false
    },
    // 选择上传图片
    uploadFile (e) {
      if (this.imageList.length < 9) {
        let that = this
        var files = e.target.files[0]

        var reader = new FileReader()
        reader.readAsDataURL(files)
        // 监听文件读取结束后事件
        reader.onloadend = function (e) {
          // var dx = (e.total / 1024) / 1024
          // if (dx >= 2) {
          //   alert('文件大小大于2M')
          //   return
          // }
          that.imageList.push(e.target.result)

          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            // 以上是将选择的图片展示出来
            let originWidth = img.naturalWidth
            let originHeight = img.naturalHeight
            let originSize = files.size / 1024 // 计算图片多少kb
            // 将图片绘制到canvas上进行压缩
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')
            let maxSize = that.maxSize
            if (originSize <= maxSize) {
              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', files)
            } else {
              let mul = originSize / maxSize
              let targetWidth = originWidth / mul
              let targetHeight = originHeight / mul
              canvas.width = targetWidth
              canvas.height = targetHeight
              context.clearRect(0, 0, targetWidth, targetHeight) // 清除画布
              context.drawImage(img, 0, 0, targetWidth, targetHeight) // 画图

              let dataURL = canvas.toDataURL('image/jpeg') // 将其转化成base64字符串
              let blob = that.dataURItoBlob(dataURL) // 转化为blob格式
              var fileName = new Date().getTime() + '.jpeg'

              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', blob, fileName)
            }
            var options = { // 设置axios的参数
              url: '/api/Upload/uploadpicture?access_token=' + that.access_token,
              data: that.formData,
              method: 'post',
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            that.axios(options).then((res) => {
              that.imageListId = that.imageListId.concat(res.data.data.id)
              console.log(that.imageListId)
            })
          }
        }
      } else {
        this.$toast({
          message: '最多选择9张图片',
          duration: 5000
        })
      }
      e.target.value = '' // 解决input type=file 同一个文件二次上传无效的问题
    },
    // base64格式转化为blob对象
    dataURItoBlob (dataURI) {
      let byteString = atob(dataURI.split(',')[1])
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ab = new ArrayBuffer(byteString.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    // 删除上传图片
    deleteImage (e) {
      this.imageList.splice(e, 1)
      this.imageListId.splice(e, 1)
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    },
    // 获取tob accessToken
    getAccessToken () {
      this.axios.get('/wechat/repair/tobAccessToken')
        .then((res) => {
          if (res.data.status === 1) {
            this.access_token = res.data.data.access_token
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    }
  }
}
</script>
<style scoped>
.common {
  padding: 10px 15px;
}
.backdrop {
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.head-wrapper {
  font-size: 15px
}
.head-wrapper .row {
  line-height: 25px;
}
.head-wrapper .row label {
  width: 125px;
}
.head-wrapper .warearrow {
  width: 12px;
  height: 12px;
  margin-left: 15px;
}
.remarks-wrapper {
  color: #969696;
}
.remarks-wrapper .remarks-textarea {
  display: flex;
}
.remarks-wrapper .remarks-textarea textarea {
  flex: 1;
  border: none;
  padding: 15px 0;
  outline: none;
  color: #c2c2c2;
  font-size: 14px;
  min-height: 50px;
}
.remarks-wrapper .remarks-textarea textarea::-webkit-input-placeholder{
  color:#c2c2c2;
}
.backdrop-bottom {
  height: 50px;
  background-color: #ffffff;
  display: flex;
}
.backdrop-bottom button {
  flex: 1;
  height: 50px;
  line-height: 49px;
  background-color: #f0f1f3;
  border-radius: none;
  border: none;
  color: #45454d;
  font-size: 15px;
}
.backdrop-bottom .entry-btn {
  background-color: #ff7c12;
  color: #ffffff;
}
.warehouselist {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 15px;
}
.warehouselist .warehouselist-bottom {
  background-color: #ffffff;
  width: 100%;
  position: absolute;
  bottom: 0;
}
.warehouselist-top {
  width: 100%;
  height: 100%;
}
.warehouselist .warehouselist-bottom label {
  display: block;
  padding: 8px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/WarehouseOut/WarehouseOutAccount.vue